
export const getCoursesById = (state) => state.courses;

export const getCoursesLoadStatus = ({ isLoading, awaitingLoad }) => ({ isLoading, awaitingLoad });